
import Header from "@/components/partials/Header.vue";
import Card from "@/components/helpers/Card.vue";
import CardContent from "@/components/helpers/Card/CardContent.vue";
import CardTitle from "@/components/helpers/Card/CardTitle.vue";
import BackgroundGray from "@/components/helpers/BackgroundGray.vue";
import Title from "@/components/style/Title.vue";
import CustomInput from "@/components/input-2/CustomInput.vue";
import Button from "@/components/input-2/Button.vue";
import Footer from "@/components/partials/Footer.vue";

export default {
  components: {
    Footer,
    Button,
    CustomInput,
    Title,
    BackgroundGray,
    CardTitle,
    CardContent,
    Card,
    Header
  },
  data() {
    return {
      form: {
        email: '',
        internal_code: ''
      },
      page: {
        image: ''
      },
      errorNotFound: false
    };
  },
  nuxtI18n: {
    paths: {
      'it': '/status-prenotazione',
      'ro': '/status-rezervare',
      'en': '/booking-status',
      'ru': '/status-bronirovaniya'
    }
  },
  methods: {
    submitForm() {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          this.$api.booking.verifyIdAndEMail(this.form.internal_code, this.form.email)
              .then((res) => {
                if (res.data.valid) {
                  console.log(this.$router);
                  this.$router.push(this.localePath({
                    name: 'booking-status-email-code',
                    params: {
                      email: this.form.email,
                      code: this.form.internal_code
                    }
                  }));
                } else {
                  this.errorNotFound = true;
                }
              })
        }
      });
    }
  },
  async fetch() {
    const response = await this.$api.contents.query({
      multiple: false,
      code: 'booking-status-form'
    });
    this.page = response.data.content;
  }
};
